import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

const Carousel = (props) => {
  const history = useHistory();
  const timerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? props.slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    };
  const clickHandler = (url) => history.push(url);
  const goToNext = useCallback(() => {
    const isLastSlide = currentIndex === props.slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, props.slides]);
  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };
  const getSlideStylesWithBackground = () => ({
    ...{
      width: "100%",
      height: "100%",
      borderRadius: "10px",
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    width: "100%",
    alignItems: "center",
    display: "flex"
  });
  const getSlidesContainerStylesWithWidth = () => ({
    ...{
      display: "flex",
      height: "100%",
      transition: "transform ease-out 0.3s",
    },
    width: `${100 * props.slides.length}%`,
    transform: `translateX(${-(currentIndex * (100 / props.slides.length))}%)`,
    alignContent: "center",
    justifyItems: "center"
  });

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      goToNext();
    }, props.transitionTime * 1000);

    return () => clearTimeout(timerRef.current);
  }, [goToNext]);

  return (
    <div style={{
      height: "100%",
      margin: "0 auto",
    }}>
      <div style={{
        position: "relative",
        height: "100%",

      }}>
        <div style={{
        }}>
          <div onClick={goToPrevious} style={{
            position: "absolute",
            top: "50%",
            transform: "translate(0, -50%)",
            left: "2%",
            fontSize: "30px",
            color: "#000",
            zIndex: 1,
            cursor: "pointer",
          }}>
            ❰
          </div>
          <div onClick={goToNext} style={{
            position: "absolute",
            top: "50%",
            transform: "translate(0, -50%)",
            right: "2%",
            fontSize: "30px",
            color: "#000",
            zIndex: 1,
            cursor: "pointer",
          }}>
            ❱
          </div>
        </div>
        <div style={{
          overflow: "hidden",
          height: "100%",

        }}>
          <div style={getSlidesContainerStylesWithWidth()}>
            {props.slides.map((slide, slideIndex) => (
              <div
                key={slideIndex}
                style={getSlideStylesWithBackground()}
              >
                {(props.clickableImages && slide.link) ? (
                  <div onClick={() => clickHandler(slide.link)} >
                      <img src={slide.url} alt={slide.title} className="cursor-pointer"/>
                  </div>
                ) : (
                  <img src={slide.url} alt={slide.title} />
                )}
              </div>

            ))}
          </div>
        </div>
        <div style={{
          display: "flex",
          justifyContent: "center",
        }}>
          {props.enableCarouselControl && props.slides && props.slides.map((_, slideIndex) => (
            <div
              style={{
                margin: "0 10px",
                cursor: "pointer",
                fontSize: "20px",
              }}
              key={slideIndex}
              onClick={() => goToSlide(slideIndex)}
            >
              ●
            </div>
          ))}
        </div>
      </div >
    </div>
  );
};

export default Carousel;